import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

import { PrescriptionService } from 'app-service';
import { DialogService } from 'app-shared-ui';

@Component({
  selector: 'app-print-prescription',
  templateUrl: './print-prescription.component.html',
  styleUrls: ['./print-prescription.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [DialogService, PrescriptionService],
})
export class PrintPrescriptionComponent {
  // Bound to the [targetUrl] input
  activeTargetUrl = 'clinic/appointments/prescription/';
  activeMode: 'live' | 'preview' | 'script' = 'live';
  zoomLevel = 100;
  showHeader = true;
  showUrlBar = false;

  public constructor(private readonly _route: Router) {
    this.activeTargetUrl =
      this.activeTargetUrl + this._route.url.split('/')[5].split('?')[0];
  }
}